import { getQueryString } from "public@tool/getQuery";
// @ts-ignore
const h: string = window.EXTERNALSERVER || getQueryString("h") || "https://dev.xylink.com";
interface IConfig {
  path: string;
}

export const config: IConfig = {
  // path: 'http://172.17.104.83:7001'
  // path: 'http://172.17.130.61:7001'
  path: h
};



// WEBPACK FOOTER //
// ./src/publics/config/index.ts